import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgChartsModule } from "ng2-charts";
import { routes } from "src/app/app.router";
import { SecureBlockchainAuthoringToolsComponent } from "./authoring-tools/secure-blockchain-authoring-tools.component";
import { DashboardComponent } from "./authoring-tools/dashboard/dashboard.component";
import { SharedModule } from "src/app/shared/shared.module";
import { IdentitySearchComponent } from "./authoring-tools/Identity-management/identity-search/identity-search.component";
import { IdentityCreateOrUpdateComponent } from "./authoring-tools/Identity-management/identity-create-or-update/identity-create-or-update.component";
import { SmartContractManagementCreateOrUpdateComponent } from "./authoring-tools/smart-contract-management/smart-contract-management-create-or-update/smart-contract-management-create-or-update.component";
import { SmartContractManagementSearchComponent } from "./authoring-tools/smart-contract-management/smart-contract-management-search/smart-contract-management-search.component";
import { SmartContractOperationSearchComponent } from "./authoring-tools/smart-contract-operation/smart-contract-operation-search/smart-contract-operation-search.component";
import { SmartContractOperationSubmitComponent } from "./authoring-tools/smart-contract-operation/smart-contract-operation-submit/smart-contract-operation-submit.component";
import { SmartContractViewSearchComponent } from "./authoring-tools/smart-contract-view/smart-contract-view-search/smart-contract-view-search.component";
import { SmartContractViewKeysComponent } from "./authoring-tools/smart-contract-view/smart-contract-view-keys/smart-contract-view-keys.component";
import { SmartContractViewHistoryComponent } from "./authoring-tools/smart-contract-view/smart-contract-view-history/smart-contract-view-history.component";
import { SmartContractAccessFlowSearchComponent } from "./authoring-tools/smart-contract-access-flow/smart-contract-access-flow-search/smart-contract-access-flow-search.component";
import { MissingAccessFlowDialogComponent } from "./authoring-tools/smart-contract-access-flow/missing-access-flow-dialog/missing-access-flow-dialog.component";
import { secureBlockchainRouter } from "./secure-blockchain.router";

@NgModule({
  declarations: [
    SecureBlockchainAuthoringToolsComponent,
    IdentitySearchComponent,
    IdentityCreateOrUpdateComponent,
    SmartContractManagementSearchComponent,
    SmartContractManagementCreateOrUpdateComponent,
    SmartContractOperationSearchComponent,
    SmartContractOperationSubmitComponent,
    SmartContractViewHistoryComponent,
    SmartContractViewKeysComponent,
    SmartContractViewSearchComponent,
    DashboardComponent,
    SmartContractAccessFlowSearchComponent,
    MissingAccessFlowDialogComponent
  ],
  imports: [
    routes,
    secureBlockchainRouter,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgbModule,
    NgChartsModule,
    SharedModule
  ]
})
export class SecureBlockchainModule { }
